import { render, staticRenderFns } from "./DashboardTracking.vue?vue&type=template&id=db650250&scoped=true"
import script from "./DashboardTracking.vue?vue&type=script&lang=js"
export * from "./DashboardTracking.vue?vue&type=script&lang=js"
import style0 from "./DashboardTracking.vue?vue&type=style&index=0&id=db650250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db650250",
  null
  
)

export default component.exports